<template>
  <svg
    width="154"
    height="154"
    viewBox="0 0 154 154"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle
      cx="77"
      cy="77"
      r="77"
    />
    <path
      d="M115.649 71.2815C118.615 73.2609 118.615 77.6199 115.649 79.5993L63.1558 114.632C59.8332 116.849 55.3803 114.467 55.3803 110.473L55.3803 40.408C55.3803 36.4134 59.8332 34.0317 63.1558 36.2491L115.649 71.2815Z"
    />
  </svg>
</template>

<style scoped lang="scss">
svg {
  circle {
    fill: var(--video-play-background, var(--ks-secondary));
  }

  path {
    fill: var(--video-play-fill, var(--ks-primarytext));
  }
}
</style>
